<div class="app-wrapper" *ngIf="access else notrulesaccess">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="'Rules'"
                    [description]="'This is where you have your system rules. These are logic based rules affecting: users, groups, project stages, artwork (statuses).'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add" [hidden]="status != STATUS_DONE">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
                </div>
            </header>
            <div class="rules-list">
                <settings-rules-rule-list
                    (selectRule)="openRule($event)"
                ></settings-rules-rule-list>
            </div>
        </div>
    </section>
</div>

<ng-template #notrulesaccess>
  <core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
</ng-template>
